import { SvgCurve, SvgTxt } from "./DrawMtrlCurve";
import { MaterialRecord, MaterialSvg } from "./Material";

function SteelCurve(activeMtrl: MaterialRecord, svg: MaterialSvg): [SvgCurve[], SvgTxt[]] {
  const E = 210; //activeMtrl.valObj["elasticityModulus"].value / 1e6;

  const yieldS = 235; //activeMtrl.valObj["yieldStrengths"].value[0]["strength"];
  const yieldE = yieldS / E;

  const ultimateS = 360;
  // activeMtrl.valObj["ultimateTensileStrengths"].value[0]["strength"];
  const ultimateE = 15 * yieldE;

  const scaleW = svg.max.x / ultimateE;
  const scaleH = svg.max.y / ultimateS;

  // stress-strain curve --------------------------------

  let curve1: SvgCurve = {
    stroke: "blue",
    width: "1",
    dash: "",
    data: "",
  };

  curve1.data = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " ";

  curve1.data += "l" + (yieldE * scaleW).toString() + "," + (-yieldS * scaleH).toString();
  curve1.data += "l" + ((ultimateE - yieldE) * scaleW).toString() + "," + (-(ultimateS - yieldS) * scaleH).toString();

  // 'fyk'-line  --------------------------------

  let curve2: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve2.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - yieldS * scaleH).toString() + " ";
  curve2.data += "l" + (yieldE * scaleW + 5).toString() + ",0";

  // 'eps_y'-line  --------------------------------

  let curve3: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve3.data = "M" + (svg.origo.x + yieldE * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve3.data += "l" + "0," + (-(yieldS * scaleH + 5)).toString();

  // 'eps_u'-line  --------------------------------

  let curve4: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve4.data = "M" + (svg.origo.x + ultimateE * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve4.data += "l" + "0," + (-(ultimateS * scaleH + 5)).toString();

  // 'fuk'-line  --------------------------------

  let curve5: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve5.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - ultimateS * scaleH).toString() + " ";
  curve5.data += "l" + (ultimateE * scaleW + 5).toString() + ",0";

  //---- collect curves -----------------

  let curves = [curve1, curve2, curve3, curve4, curve5];

  //---- texts -----------------

  let txts: SvgTxt[] = [
    {
      x: (svg.origo.x + yieldE * scaleW).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + yieldE * scaleW).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "y",
    },
    {
      x: (svg.origo.x + ultimateE * scaleW).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + ultimateE * scaleW).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "u",
    },
    {
      x: (svg.origo.x - 30).toString(),
      y: (svg.origo.y - yieldS * scaleH).toString(),
      style: {
        fontSize: "20px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "f",
    },
    {
      x: (svg.origo.x - 25).toString(),
      y: (svg.origo.y + 5 - yieldS * scaleH).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "y",
    },
    {
      x: (svg.origo.x - 30).toString(),
      y: (svg.origo.y - ultimateS * scaleH).toString(),
      style: {
        fontSize: "20px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "f",
    },
    {
      x: (svg.origo.x - 25).toString(),
      y: (svg.origo.y + 5 - ultimateS * scaleH).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "u",
    },
  ];

  return [curves, txts];
}

export default SteelCurve;
